type Tone = 'neutral' | 'amber' | 'emerald' | 'red' | 'blue';

const TONES: Record<Tone, string> = {
  neutral: 'bg-slate-100 text-slate-700',
  amber: 'bg-amber-100 text-amber-800',
  emerald: 'bg-emerald-100 text-emerald-800',
  red: 'bg-red-100 text-red-800',
  blue: 'bg-blue-100 text-blue-800',
};

/** Kurzer Statushinweis. Farbzuordnung wie im Buchungsbestand. */
export function Badge({ tone = 'neutral', children }: { tone?: Tone; children: React.ReactNode }) {
  return (
    <span
      className={['inline-block rounded px-2 py-0.5 text-xs font-medium', TONES[tone]].join(' ')}
    >
      {children}
    </span>
  );
}

/** Farbpunkt für Fahrzeug- und Gruppenfarben. */
export function ColorDot({ color, title }: { color: string; title?: string }) {
  return (
    <span
      className="inline-block size-3 shrink-0 rounded-full border border-black/10 align-middle"
      style={{ backgroundColor: color }}
      title={title}
    />
  );
}
